<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <add-responsibility>
        </add-responsibility> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import addResponsibility from './todo-add-responsibility-form'
export default {
    components: {
        addResponsibility
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/base-add-responsibility-form.vue